// Permanent shared title rule: Organic and Cotton use the same existing green.
// Presentation only: catalog titles, attributes, metadata and JSON remain plain text.
(() => {
  const selector = '[data-product-title], .product-details h1, product-card h1, product-card h2, product-card h3, product-card [role="heading"], .resource-card__title, .cart-items__title, .sticky-add-to-cart__title, a[href*="/products/"]';
  const word = /(?<![\p{L}\p{N}_])(?:organic|cotton)(?![\p{L}\p{N}_])/giu;
  const negative = /(?:\bnon\s*[-–—]?\s*|\bnot\s+|\bno\s+)$/iu;
  function render(root) {
    const targets = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) targets.unshift(root);
    for (const target of targets) {
      const walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      for (const node of nodes) {
        if (node.parentElement.closest('.organic-title-word, script, style, [data-organic-badge], svg')) continue;
        const text = node.textContent;
        const matches = [...text.matchAll(word)].filter(m => m[0].toLowerCase() !== 'organic' || !negative.test(text.slice(0, m.index)));
        if (!matches.length) continue;
        const fragment = document.createDocumentFragment();
        let offset = 0;
        for (const match of matches) {
          fragment.append(text.slice(offset, match.index));
          const span = document.createElement('span');
          span.className = 'organic-title-word';
          span.textContent = match[0];
          fragment.append(span);
          offset = match.index + match[0].length;
        }
        fragment.append(text.slice(offset));
        node.replaceWith(fragment);
      }
    }
  }
  const start = () => {
    render(document);
    new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE && !node.matches('.organic-title-word')) render(node);
        else if (node.nodeType === Node.TEXT_NODE && node.parentElement && !node.parentElement.closest('.organic-title-word')) render(node.parentElement);
      }
    }).observe(document.body, { subtree: true, childList: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
